module.exports = __webpack_public_path__ + "img/dropfile.c6d3923d.svg";